import React from 'react'
import {getComponentDisplayName} from '@modifi/utilities'

import {ScreenSizeProvider} from '../../common-components/screen-size-helper'

function withScreenSizeProvider<P extends {innerRef?: never}, T extends any>(
  WrappedComponent: React.ComponentType<P>
) {
  const ScopedComponent: React.FC<Omit<P, 'innerRef'> & {innerRef: React.ForwardedRef<T>}> = ({
    // eslint-disable-next-line react/prop-types
    innerRef,
    ...props
  }) => (
    <ScreenSizeProvider>
      <WrappedComponent {...(props as unknown as P)} ref={innerRef} />
    </ScreenSizeProvider>
  )

  ScopedComponent.displayName = `withScreenSizeProvider(${getComponentDisplayName(
    WrappedComponent
  )})`

  return React.memo(
    React.forwardRef<T, P>((props, ref) => <ScopedComponent {...props} innerRef={ref} />)
  )
}

export default withScreenSizeProvider
